import * as React from 'react';
import styled from 'styled-components';

const VerticalCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const Container = ({children, center = 'none'}) => {
    switch (center) {
        case 'vertical':
            return <VerticalCenter className="container">{children}</VerticalCenter>;
        case 'horizontal':
            return <div className="container center">{children}</div>;
        case 'both':
            return <VerticalCenter className="container center">{children}</VerticalCenter>;
        default:
            return <div className="container">{children}</div>;
    }
};

export default Container;
